const isObject = function (o: any) {
  return o === Object(o) && !isArray(o) && typeof o !== "function";
};
const isArray = function (a: any) {
  return Array.isArray(a);
};

export const pascalToSnake = (inputString: string) => {
  return (
    inputString.slice(0, 1).toLowerCase() +
    inputString
      .split("")
      .slice(1)
      .map((char: string) => {
        if (char == char.toUpperCase()) return "_" + char.toLowerCase();
        else return char;
      })
      .join("")
  );
};

export const pascalKeysToSnake = (o: any) => {
  if (isObject(o)) {
    interface Map {
      [key: string]: string | undefined;
    }

    const n: Map = {};

    Object.keys(o).forEach((k) => {
      n[pascalToSnake(k)] = pascalKeysToSnake(o[k]);
    });

    return n;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return pascalKeysToSnake(i);
    });
  }

  return o;
};

// To Camel (from snake)
export const snakeToCamel = (s: string) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
};
export const snakeKeysToCamel = (o: any) => {
  if (isObject(o)) {
    const n: Record<string, any> = {};

    Object.keys(o).forEach((k) => {
      n[snakeToCamel(k)] = snakeKeysToCamel(o[k]);
    });

    return n;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return snakeKeysToCamel(i);
    });
  }

  return o;
};

// To snake (from camel)
export const camelToSnake = (inputString: string) => {
  return inputString
    .split("")
    .map((character) => {
      if (character == character.toUpperCase()) {
        return "_" + character.toLowerCase();
      } else {
        return character;
      }
    })
    .join("");
};
export const camelKeysToSnake = (o: any) => {
  if (isObject(o)) {
    const n: Record<string, any> = {};

    Object.keys(o).forEach((k) => {
      n[camelToSnake(k)] = camelKeysToSnake(o[k]);
    });

    return n;
  } else if (isArray(o)) {
    return o.map((i: any) => {
      return camelKeysToSnake(i);
    });
  }

  return o;
};

// To kebab case (from camel)
export const toKebab = (inputString: string) => {
  return inputString
    .replace(/\B([A-Z])(?=[a-z])/g, "-$1")
    .replace(/\B([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase();
};
